export enum CompaniesActions {
    FETCH_COMPANIES_DATA = 'FETCH_COMPANIES_DATA'
}
